import { Alert, Button, Stack, Text } from "@chakra-ui/react";
import { observer } from "mobx-react";
import { useStores } from "../../../../../shared/stores/RootStore";
import { useState } from "react";
import { UploadNodes } from "./UploadNodes";
import { t } from "i18next";
import { MapillaryImportControls } from "./MapillaryImportControls";

enum Views {
  Upload = "Upload",
  Mapillary = "Mapillary",
}

const PopulateWayControlsBase: React.FC = () => {
  const { osaWayStore } = useStores();

  const [view, setView] = useState<Views>();
  const osaWay = osaWayStore.getSelected()!;

  const canCreate = osaWay.permissions.canCreate;
  const onCancel = () => setView(undefined);

  return (
    <Stack>
      <Alert.Root status={"info"}>
        <Alert.Indicator />
        <Stack flexGrow={1}>
          <Alert.Title>This route is empty.</Alert.Title>

          {canCreate ? (
            !view && (
              <>
                <Button {...btnProps} onClick={() => setView(Views.Upload)}>
                  Upload images
                </Button>
                <Button {...btnProps} onClick={() => setView(Views.Mapillary)}>
                  Import from Mapillary
                </Button>
              </>
            )
          ) : (
            <Text fontSize="sm">{`${t(
              "shared:project.modal.route.noPermission"
            )}`}</Text>
          )}
        </Stack>
      </Alert.Root>

      {view === Views.Upload && <UploadNodes onCancel={onCancel} />}

      {view === Views.Mapillary && (
        <MapillaryImportControls onCancel={onCancel} />
      )}
    </Stack>
  );
};

export const PopulateWayControls = observer(PopulateWayControlsBase);

const btnProps = {
  size: "sm" as "sm",
  fontSize: "sm",
  colorPalette: "primary",
};
